// extracted by mini-css-extract-plugin
export default {"selected":"_00c03476f7","un":"be85b9eec6"};